import usePartyCurrency from '../../../parties/src/hooks/usePartyCurrency';
import { useFlowsSession } from '../api/getFlowsSessionById';
import useSessionId from './useSessionId';

const useFlowsCurrency = () => {
  const sessionId = useSessionId();
  const { data: session } = useFlowsSession(sessionId);
  return usePartyCurrency(session?.prospect.id);
};

export default useFlowsCurrency;
